import { forwardRef } from "react";
import { Flex } from "../Flex/Flex";
import type { FlexProps } from "../Flex/types";

export const VStack = forwardRef<HTMLElement, FlexProps>(function VStack(props, ref) {
    return <Flex direction="column" ref={ref} {...props} />;
});
